export default {"src":"/_next/static/media/steeringWheel_40.8873bc36.svg","height":40,"width":40,"blurWidth":0,"blurHeight":0};